import styled from "@emotion/styled";
import { Styles } from "@tpd-web-common-libs/nodejs-library";

export const ContainerDiv = styled.div<{ titolo: string }>`
  padding: 1px 0;
  padding-top: ${(props) => (!props.titolo ? "109px" : "")};
  background-color: ${Styles.Themes.UnipolColors.blueTen};
  ${Styles.PageColorUtils.pageColorThemeOnly(
    (pageColor: any) => `
      background-color: ${pageColor.lightColor};
    `
  )}
  color: #5393bc;
  .tpd-short-text,
  .tpd-content-description,
  .tpd-cta-preview-mode-container {
    color: ${Styles.Themes.UnipolColors.blueOne};
  }

  .tpd-a-chi-si-rivolge-title {
    margin: 0 calc(100% * 1 / 24);
    padding-top: 100px;
    padding-bottom: 100px;
  }

  .tpd-short-text {
    font-family: Unipol Medium;
    font-size: 30px;
    line-height: 37px;
    margin: 0;
    padding-bottom: 30px;
    padding-top: 20px;
    color: #5393bc;
    &.blue {
      color: ${Styles.Themes.UnipolColors.blueOne};
    }
  }

  .tpd-content-title {
    ${Styles.PageColorUtils.pageColorThemeOnly(
      (pageColor: any) => `
        color: ${pageColor.mainColor};
      `
    )}
  }

  ${Styles.BreakpointsUtils.mobileOnly(`
    .tpd-a-chi-si-rivolge-title {
      margin: 0px calc(100% * 1 / 24);
      padding-bottom: 50px;
      padding-left: 4px;
      padding-top: 109px;
      padding-right: 4px;
      &.tpd-pt-0 {
        padding-top: 0;
      }
    }

    .tpd-short-text {
      padding-left: 4px;
      padding-right: 4px;
    }
`)}

  ${Styles.BreakpointsUtils.tabletOnly(`
    .tpd-a-chi-si-rivolge-title {
      padding-left: 4px;
      padding-right: 4px;
      padding-top: 90px;
      padding-bottom: 60px;
      &.tpd-pt-0 {
        padding-top: 0;
      }
    }
    .tpd-short-text {
      font-size: 33px;
      padding-left: 4px;
      padding-right: 4px;
    }
  `)}

  ${Styles.BreakpointsUtils.desktopOnly(`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .tpd-image-container {
      .tpd-image-preview-mode-container {
        img {
          height: auto;
          width: 100%;          
        }
      }
    }

    .tpd-a-chi-si-rivolge-title {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      max-width: 1280px;
    }

    .tpd-short-text {
      width: 100%;
      max-width: 952px;
      margin-left: 12.5%;
      margin-right: 12.5%;
      padding-bottom: 36px;
      font-size: 34px;
    }
  `)}

  @media (min-width: 769px) {
    padding-top: ${(props) => (!props.titolo ? "90px" : "")};
  }

  @media (min-width: 1281px) {
    padding-top: ${(props) => (!props.titolo ? "0" : "")};
  }
`;
